module.exports = __webpack_public_path__ + "static/media/goldenprize-tuna-mayonnaise-lid.6ac39971.png";